import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { installDiagnostics } from './app/diagnostics.ts';
import { initSentry } from './app/sentry.ts';
import './index.css';
import { routeTree } from './routeTree.gen.ts';

initSentry();
installDiagnostics();

const router = createRouter({ routeTree, defaultPreload: 'intent' });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const container = document.getElementById('root');
if (container === null) {
  throw new Error('#root não existe no index.html');
}

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
